import { jsx, jsxs } from "react/jsx-runtime";
function ServerError() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "440",
        height: "360",
        viewBox: "0 0 440 360",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_1362_1048)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M234.892 167.904L347.48 227.768L236.823 291.655L124.235 231.791L136.957 187.693L234.892 167.904Z",
                        fill: "#5B6D84"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M164.616 225.098C165.47 224.605 166.867 224.581 167.737 225.044L238.177 262.497C239.047 262.96 239.061 263.734 238.207 264.227L91.608 348.866C86.4874 351.823 78.1042 351.969 72.8836 349.193L15.0474 318.441C11.567 316.59 11.5129 313.492 14.9266 311.522L164.616 225.098Z",
                        fill: "#8396AE"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "12.6323",
                        y: "308.292",
                        width: "6",
                        height: "7.5531",
                        fill: "#8396AE"
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter0_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("path", {
                            d: "M170.964 215.217L242.724 253.373C243.16 253.604 243.166 253.991 242.74 254.237L90.7966 341.962C85.6761 344.918 77.2929 345.064 72.0723 342.289L15.2791 312.091C11.7987 310.241 11.7446 307.143 15.1583 305.172L170.964 215.217Z",
                            fill: "#D0D9E9"
                        })
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "128.976",
                        height: "34.1141",
                        transform: "matrix(0.866025 -0.5 0 1 236.799 257.994)",
                        fill: "#ABB6CC"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "129.894",
                        height: "130.345",
                        transform: "matrix(0.882948 0.469472 -0.866025 0.5 235.508 131.456)",
                        fill: "#FBFDFF"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "128.976",
                        height: "31.6071",
                        transform: "matrix(0.866025 -0.5 0 1 236.896 217.913)",
                        fill: "#ABB6CC"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M237.224 257.549L123.017 196.824V231.154L135.088 237.572V212.328L222.163 258.626V283.871L237.224 291.879V257.549Z",
                        fill: "#D7E0F4"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "239.884",
                        cy: "326.092",
                        rx: "27.924",
                        ry: "16.6289",
                        fill: "#1348C0"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "211.96",
                        y: "318.248",
                        width: "55.8481",
                        height: "8.78509",
                        fill: "#1348C0"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "239.884",
                        cy: "317.934",
                        rx: "27.924",
                        ry: "16.6289",
                        fill: "#2166FF"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "128.976",
                        height: "31.5493",
                        transform: "matrix(0.882948 0.469472 0 1 123.017 157.362)",
                        fill: "#D6DFED"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "128.868",
                        height: "128.868",
                        transform: "matrix(0.882948 0.469472 -0.866025 0.5 234.563 93.067)",
                        fill: "#FBFDFF"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "128.976",
                        height: "31.6071",
                        transform: "matrix(0.866025 -0.5 0 1 236.799 178.439)",
                        fill: "#ABB6CC"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "128.976",
                        height: "31.5493",
                        transform: "matrix(0.882948 0.469472 0 1 122.921 117.947)",
                        fill: "#D6DFED"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "129.093",
                        height: "129.093",
                        transform: "matrix(0.882948 0.469472 -0.866025 0.5 234.616 53.3459)",
                        fill: "#FAFCFF"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "73.1344",
                        height: "73.1344",
                        transform: "matrix(0.882948 0.469472 -0.866025 0.5 235.988 79.9055)",
                        fill: "#DDE1E9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M293.083 156.819L289.393 158.949V171.439L293.083 169.309V156.819ZM278.324 165.34L274.634 167.471V179.961L278.324 177.83V165.34ZM270.944 169.601L267.254 171.731V184.222L270.944 182.091V169.601ZM282.014 163.21L285.704 161.08V173.57L282.014 175.7V163.21ZM296.773 154.688L300.463 152.558V165.048L296.773 167.179V154.688ZM307.843 148.297L304.153 150.428V162.918L307.843 160.788V148.297ZM311.533 146.167L315.223 144.037V156.527L311.533 158.657V146.167ZM322.602 139.776L318.912 141.906V154.397L322.602 152.266V139.776Z",
                        fill: "url(#paint0_linear_1362_1048)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M293.083 196.292L289.393 198.423V210.913L293.083 208.783V196.292ZM278.324 204.814L274.634 206.944V219.434L278.324 217.304V204.814ZM270.944 209.074L267.254 211.205V223.695L270.944 221.565V209.074ZM282.014 202.683L285.704 200.553V213.043L282.014 215.174V202.683ZM296.773 194.162L300.463 192.032V204.522L296.773 206.652V194.162ZM307.843 187.771L304.153 189.901V202.392L307.843 200.261V187.771ZM311.533 185.641L315.223 183.51V196.001L311.533 198.131V185.641ZM322.602 179.25L318.912 181.38V193.87L322.602 191.74V179.25Z",
                        fill: "url(#paint1_linear_1362_1048)"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M293.083 237.627L289.393 239.757V252.247L293.083 250.117V237.627ZM278.324 246.148L274.634 248.279V260.769L278.324 258.639V246.148ZM270.944 250.409L267.254 252.539V265.03L270.944 262.899V250.409ZM282.014 244.018L285.704 241.888V254.378L282.014 256.508V244.018ZM296.773 235.496L300.463 233.366V245.856L296.773 247.987V235.496ZM307.843 229.106L304.153 231.236V243.726L307.843 241.596V229.106ZM311.533 226.975L315.223 224.845V237.335L311.533 239.465V226.975ZM322.602 220.584L318.912 222.714V235.205L322.602 233.074V220.584Z",
                        fill: "url(#paint2_linear_1362_1048)"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "151.924",
                        cy: "266.786",
                        rx: "27.924",
                        ry: "16.6289",
                        fill: "#1348C0"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "124",
                        y: "258.943",
                        width: "55.8481",
                        height: "8.78509",
                        fill: "#1348C0"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "151.924",
                        cy: "258.629",
                        rx: "27.924",
                        ry: "16.6289",
                        fill: "#2166FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M147.465 257.934L145.058 255.758L157.132 249.488L167.779 255.149L164.425 257.245L157.053 253.325L151.668 256.169C152.106 256.206 152.658 256.293 153.322 256.428C153.997 256.557 154.635 256.781 155.235 257.1C156.156 257.589 156.804 258.129 157.18 258.72C157.576 259.31 157.705 259.93 157.565 260.58C157.436 261.235 157.048 261.914 156.402 262.617C155.757 263.32 154.867 264.025 153.734 264.733C152.75 265.348 151.687 265.857 150.543 266.26C149.42 266.663 148.246 266.93 147.022 267.06C145.798 267.191 144.583 267.16 143.378 266.968C142.193 266.775 141.053 266.386 139.956 265.803C139.139 265.369 138.486 264.867 137.999 264.297C137.522 263.722 137.252 263.107 137.189 262.452C137.125 261.798 137.295 261.13 137.697 260.447C138.11 259.77 138.808 259.113 139.791 258.474L143.703 260.554C143.119 260.991 142.702 261.407 142.451 261.803C142.212 262.204 142.143 262.575 142.247 262.918C142.37 263.259 142.665 263.554 143.131 263.802C143.586 264.044 144.078 264.185 144.608 264.225C145.147 264.259 145.704 264.21 146.278 264.079C146.863 263.953 147.46 263.753 148.07 263.48C148.7 263.205 149.318 262.879 149.924 262.5C150.531 262.121 151.02 261.75 151.394 261.385C151.777 261.014 152.023 260.65 152.132 260.295C152.262 259.939 152.24 259.605 152.067 259.295C151.894 258.984 151.559 258.697 151.062 258.433C150.4 258.08 149.779 257.894 149.199 257.873C148.62 257.852 148.042 257.873 147.465 257.934Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "90.9242",
                        cy: "302.786",
                        rx: "27.924",
                        ry: "16.6289",
                        fill: "#1348C0"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "63.0001",
                        y: "294.943",
                        width: "55.8481",
                        height: "8.78509",
                        fill: "#1348C0"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "90.924",
                        cy: "294.629",
                        rx: "27.924",
                        ry: "16.6289",
                        fill: "#2166FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M99.9088 296.516L96.2416 298.807C94.582 299.844 93.0056 300.65 91.5126 301.224C90.0196 301.798 88.6109 302.169 87.2865 302.339C85.9824 302.507 84.7583 302.494 83.6141 302.3C82.4799 302.099 81.4368 301.746 80.4849 301.24C79.7296 300.838 79.1301 300.393 78.6865 299.904C78.2529 299.409 78.0006 298.873 77.9297 298.295C77.879 297.716 78.0299 297.095 78.3825 296.432C78.7454 295.774 79.3303 295.074 80.137 294.33C80.964 293.586 82.0434 292.798 83.3751 291.966L87.0422 289.675C88.7118 288.631 90.2882 287.826 91.7713 287.258C93.2647 286.696 94.6687 286.333 95.9831 286.17C97.2976 286.007 98.5169 286.029 99.6412 286.236C100.775 286.436 101.818 286.79 102.77 287.296C103.526 287.698 104.125 288.143 104.569 288.632C105.012 289.12 105.259 289.648 105.31 290.215C105.38 290.781 105.239 291.396 104.886 292.059C104.544 292.716 103.959 293.417 103.132 294.161C102.315 294.899 101.24 295.684 99.9088 296.516ZM91.7317 297.03L96.5169 294.04C97.3318 293.531 98.0112 293.064 98.5549 292.641C99.0986 292.217 99.5119 291.839 99.7948 291.507C100.088 291.168 100.265 290.86 100.326 290.583C100.398 290.31 100.364 290.068 100.225 289.856C100.095 289.638 99.8803 289.449 99.5803 289.289C99.1974 289.086 98.7566 288.966 98.2578 288.931C97.7689 288.89 97.1972 288.948 96.5426 289.105C95.898 289.257 95.166 289.523 94.3465 289.903C93.5271 290.284 92.6106 290.79 91.5969 291.424L86.8117 294.414C85.9869 294.929 85.2976 295.402 84.7439 295.832C84.2105 296.261 83.7925 296.648 83.4897 296.992C83.1973 297.343 83.0102 297.657 82.9286 297.935C82.8568 298.208 82.8857 298.453 83.0152 298.671C83.1447 298.889 83.3646 299.081 83.675 299.246C84.0579 299.45 84.4987 299.569 84.9975 299.604C85.5166 299.639 86.0983 299.575 86.7425 299.412C87.3867 299.248 88.1183 298.971 88.9374 298.579C89.7766 298.186 90.7081 297.67 91.7317 297.03Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M246.922 319.309L243.255 321.601C241.596 322.638 240.019 323.443 238.526 324.017C237.033 324.591 235.624 324.963 234.3 325.132C232.996 325.301 231.772 325.288 230.628 325.093C229.493 324.893 228.45 324.539 227.498 324.033C226.743 323.631 226.144 323.186 225.7 322.697C225.266 322.203 225.014 321.666 224.943 321.088C224.893 320.509 225.043 319.889 225.396 319.225C225.759 318.568 226.344 317.867 227.151 317.124C227.978 316.38 229.057 315.592 230.389 314.759L234.056 312.468C235.725 311.425 237.302 310.619 238.785 310.051C240.278 309.489 241.682 309.127 242.997 308.963C244.311 308.8 245.53 308.822 246.655 309.029C247.789 309.23 248.832 309.583 249.784 310.09C250.539 310.491 251.139 310.936 251.582 311.425C252.026 311.914 252.273 312.442 252.323 313.009C252.394 313.575 252.253 314.189 251.9 314.853C251.557 315.509 250.973 316.21 250.146 316.954C249.328 317.692 248.254 318.477 246.922 319.309ZM238.745 319.823L243.53 316.833C244.345 316.324 245.025 315.858 245.568 315.434C246.112 315.011 246.525 314.633 246.808 314.3C247.101 313.962 247.278 313.654 247.34 313.376C247.411 313.104 247.378 312.862 247.238 312.65C247.109 312.431 246.894 312.242 246.594 312.083C246.211 311.879 245.77 311.76 245.271 311.725C244.782 311.683 244.211 311.741 243.556 311.899C242.912 312.05 242.18 312.316 241.36 312.697C240.541 313.077 239.624 313.584 238.61 314.217L233.825 317.207C233 317.723 232.311 318.195 231.757 318.625C231.224 319.054 230.806 319.441 230.503 319.786C230.211 320.136 230.024 320.45 229.942 320.729C229.87 321.001 229.899 321.246 230.029 321.465C230.158 321.683 230.378 321.875 230.689 322.04C231.071 322.243 231.512 322.363 232.011 322.398C232.53 322.433 233.112 322.368 233.756 322.205C234.4 322.042 235.132 321.764 235.951 321.372C236.79 320.979 237.722 320.463 238.745 319.823Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "25.4159",
                        height: "25.5959",
                        transform: "matrix(0.882948 0.469472 -0.866025 0.5 389.222 234.393)",
                        fill: "#E2E9F5"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "25.3456",
                        height: "25.085",
                        transform: "matrix(0.866025 -0.5 0 1 389.712 259.27)",
                        fill: "#B1BACD"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "25.6618",
                        height: "25.1387",
                        transform: "matrix(0.882948 0.469472 0 1 367.054 247.218)",
                        fill: "#CCD6E4"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        opacity: "0.3",
                        d: "M172.564 6H300.143L300.589 114.397L237.245 150.53L172.564 116.182V6Z",
                        fill: "url(#paint3_linear_1362_1048)"
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter1_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14.881",
                            height: "2.11073",
                            transform: "matrix(0.884051 -0.479532 0.479818 0.8705 395.55 258.579)",
                            fill: "#8396AE"
                        })
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter2_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14.7606",
                            height: "2.11073",
                            transform: "matrix(0.884051 -0.479532 0.479818 0.8705 398.666 265.24)",
                            fill: "#8396AE"
                        })
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter3_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14.2631",
                            height: "2.11073",
                            transform: "matrix(0.884051 -0.479532 0.479818 0.8705 402.22 272.024)",
                            fill: "#8396AE"
                        })
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter4_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "13.3719",
                            height: "2.11073",
                            transform: "matrix(0.884051 -0.479532 0.479818 0.8705 405.855 278.338)",
                            fill: "#8396AE"
                        })
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter5_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "2.30092",
                            height: "39.8206",
                            rx: "1.15046",
                            transform: "matrix(0.990268 -0.139173 0.479818 0.8705 390.8 253.457)",
                            fill: "#8396AE"
                        })
                    }),
                    /*#__PURE__*/ jsx("g", {
                        filter: "url(#filter6_i_1362_1048)",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "2.30092",
                            height: "39.8206",
                            rx: "1.15046",
                            transform: "matrix(0.990268 -0.139173 0.479818 0.8705 402.815 245.14)",
                            fill: "#8396AE"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter0_i_1362_1048",
                        x: "12.6329",
                        y: "215.217",
                        width: "230.422",
                        height: "129.061",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "-24.9805",
                                dy: "14.2745"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.301817 0 0 0 0 0.395655 0 0 0 0 0.51556 0 0 0 0.35 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter1_i_1362_1048",
                        x: "395.55",
                        y: "251.444",
                        width: "14.1683",
                        height: "8.97327",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dy: "-0.616816"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter2_i_1362_1048",
                        x: "398.666",
                        y: "258.162",
                        width: "14.0619",
                        height: "8.91553",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dy: "-0.616816"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter3_i_1362_1048",
                        x: "402.22",
                        y: "265.184",
                        width: "13.6221",
                        height: "8.677",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dy: "-0.616816"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter4_i_1362_1048",
                        x: "405.855",
                        y: "271.925",
                        width: "12.8342",
                        height: "8.24963",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dy: "-0.616816"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter5_i_1362_1048",
                        x: "391.225",
                        y: "253.284",
                        width: "20.535",
                        height: "34.6896",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "-0.616816"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.360784 0 0 0 0 0.439216 0 0 0 0 0.537255 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter6_i_1362_1048",
                        x: "403.24",
                        y: "244.967",
                        width: "20.535",
                        height: "34.6896",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "-0.616816"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.360784 0 0 0 0 0.439216 0 0 0 0 0.537255 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1362_1048"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_1362_1048",
                        x1: "267.254",
                        y1: "177.976",
                        x2: "322.602",
                        y2: "177.976",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#2166FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#627791"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint1_linear_1362_1048",
                        x1: "267.254",
                        y1: "217.45",
                        x2: "322.602",
                        y2: "217.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#2166FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#627791"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint2_linear_1362_1048",
                        x1: "267.254",
                        y1: "258.784",
                        x2: "322.602",
                        y2: "258.784",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#2166FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#627791"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint3_linear_1362_1048",
                        x1: "236.799",
                        y1: "10.0147",
                        x2: "222.815",
                        y2: "149.124",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#BAC9FF",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#165DFF",
                                stopOpacity: "0.74"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_1362_1048",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "440",
                            height: "360",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}
export { ServerError as default };
